export var verificationCodeFieldTheme = {
  baseStyle: _ref => {
    var {
      length
    } = _ref;
    return {
      container: {
        maxWidth: '490px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'xs'
      },
      form: {
        gap: 's',
        gridRowGap: 'xs',
        justifyContent: 'center',
        gridTemplateColumns: "repeat(".concat(length, ", minmax(0, 48px))")
      },
      input: {
        textStyle: 'body2',
        textAlign: 'center',
        paddingLeft: 'none'
      }
    };
  }
};
//# sourceMappingURL=VerificationCodeField.theme.js.map